import type { Achievement } from "../achievement.types";
import { freeMoves } from "../moveHistory";

export const thoseWhoKnowAchievement: Achievement = {
  id: "thoseWhoKnow",
  name: "Those Who Know",
  icon: "eye-outline",
  description:
    "Chose the rarest word offered when it was also a Local Optimal move.",
  isProgressive: true,
  // Any move but the winning click on the target, backtracked ones included.
  check: (gameReport, gameStatus) => {
    if (!["won", "given_up"].includes(gameStatus) || !gameReport) return false;
    return freeMoves(gameReport, gameStatus).some(
      (m) =>
        m.playerChose !== gameReport.targetWord &&
        m.choseRarestNeighbor === true &&
        (m.isGlobalOptimal === true || m.isLocalOptimal === true),
    );
  },
};
